import { Button, ButtonProps } from '@chakra-ui/react';

type ActionButtonProps = ButtonProps & {
  placement?: 'header' | 'floating';
};

export const ActionButton = ({
  placement = 'floating',
  ...props
}: ActionButtonProps) => {
  return (
    <Button
      variant="solid"
      size={{ mobile: 'md', desktop: 'lg' }}
      fontWeight="normal"
      borderRadius="5px"
      {...props}
    />
  );
};
